import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import { PhoneLogin } from "@/components/PhoneLogin";
import { AccessDenied } from "@/components/AccessDenied";
import { Loader2 } from "lucide-react";
import { getFirstAccessibleConsoleRoute } from "@/constants/consoleNavigation";

const Index = () => {
  const navigate = useNavigate();
  const { hasAnyPermission, hasPermission, isAuthenticated, isLoading } =
    useAuthStore();
  const landingRoute = getFirstAccessibleConsoleRoute({
    hasPermission,
    hasAnyPermission,
  });

  useEffect(() => {
    if (isAuthenticated && !isLoading && landingRoute) {
      navigate(landingRoute, { replace: true });
    }
  }, [isAuthenticated, isLoading, landingRoute, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-muted">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <PhoneLogin />;
  }

  if (!landingRoute) {
    return (
      <AccessDenied description="Your account does not currently have access to any Console page." />
    );
  }

  // Show loading while redirecting
  return (
    <div className="min-h-screen flex items-center justify-center bg-muted">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
    </div>
  );
};

export default Index;
